import { useAppSelector } from 'src/reducer/hooks';
import { selectRawAllProgram } from 'src/reducer/programSlice';

function useKycLevels() {
  const rawAllProgram = useAppSelector(selectRawAllProgram);

  const getEnumKycLevels = () => {
    if (!rawAllProgram || rawAllProgram.length === 0) return {};

    return rawAllProgram.reduce((acc: any, { kycLevel }) => {
      return {
        ...acc,
        [kycLevel]: kycLevel,
      };
    }, {});
  };

  return { EnumKycLevels: getEnumKycLevels() };
}

export default useKycLevels;
